'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(document.getElementsByClassName('package-delivered-checkbox')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var checkbox = _step.value;

            checkbox.addEventListener('click', packageDeliveredClick);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function packageDeliveredClick(event) {
        var checkbox = event.target;
        var deliveryNoteId = parseInt(checkbox.dataset.id);
        deliveryNoteService.updatePackageDelivered({ id: deliveryNoteId, packageDelivered: !!checkbox.checked });
    }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryNoteService = abp.services.api.deliverynote;

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/customerGrid.js
// module id = 927
// module chunks = 0